@if (
  {
    isDrawerVisible: isDrawerVisible$ | async,
    previousShift: previousShift$ | async,
    nextTimelineCard: nextTimelineCard$ | async,
    staySuggestionInfo: staySuggestionInfo$ | async,
  };
  as data
) {
  @if (data.isDrawerVisible) {
    <wilson-create-stays-drawer-view
      [showIgnoreStayToggle]="true"
      [isUserFieldReadOnly]="true"
      [showMask]="true"
      [prefillValues]="
        data.previousShift && data.nextTimelineCard
          ? staysDrawerHelperService.preparePrefillCreateStayObject(
              data.previousShift,
              data.nextTimelineCard
            )
          : data.staySuggestionInfo
            ? staysDrawerHelperService.preparePrefillCreateStayFromBasicInfo(
                data.staySuggestionInfo
              )
            : undefined
      "
      [sector]="sector$ | async"
      [disableButtons]="isSaveOperationOnGoingSignal()"
      [isSaving]="isSaveOperationOnGoingSignal()"
      (closeDrawer)="closeDrawer()"
      (confirm)="confirm($event)"
      (confirmAndCreateReimbursement)="confirmAndCreateReimbursement($event)"
      (handleInvoice)="staysAttachmentsHelperService.handleInvoice($event)"
      (handleAttachments)="
        staysAttachmentsHelperService.handleAttachments($event)
      "
    ></wilson-create-stays-drawer-view>
  }
}
